import React from "react";
import { Link } from "react-router-dom";
import Background from "./../images/new-updated-images/our-services/accounting-and-finance/our-service-accounting-and-finance-background.jpg";
import informationTechnologyImage from "./../images/new-updated-images/our-services/accounting-and-finance/our-service-accounting-and-finance-content.jpg";
import Footer from "../components/Layout/Footer";
import bnr3 from "./../images/lines.png";

export default function AccountingAndFinancePage() {
  // Add title
  document.getElementById("titleText").innerText =
    "Staffing Connect - Our Services - Accounting & Finance";

  return (
    <div className="page-wraper">
      <div className="page-content1 bg-white">
        <div
          className="dez-bnr-inr overlay-black-middle"
          style={{ backgroundImage: `url(${Background})`, height: 580, marginTop:
          window.location.pathname == "/mobile/accounting-and-finance"
            ? "0rem"
            : "" }}
        >
          <div className="container">
            <div className="dez-bnr-inr-entry">
              <h1 className="text-white">
                <b style={{ display: "none" }}>
                  Staffing Connect - Our Services -
                </b>
                Accounting & Finance
              </h1>
              <div className="breadcrumb-row">
                <ul className="list-inline">
                  <li>
                  {window.location.pathname == "/mobile/accounting-and-finance" ? (
                      "Home"
                    ) : (
                      <a href={"/"}>Home</a>
                    )}
                  </li>
                  <li>Our Services</li>
                  <li>Accounting & Finance</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="content-block">
          <div className="section-full content-inner overlay-white-middle">
            <div className="container">
              <div className="row align-items-center m-b5 mb-0">
                <div className="section-head text-black text-center col-lg-12">
                  <h2 className="text-uppercase m-b0">Accounting & Finance </h2>                  
                </div>
              </div>

              <div className="row  m-b10">
                <div className="col-md-12 col-lg-6">
                  <img src={informationTechnologyImage} alt="" />
                </div>
                <div className="col-md-12 col-lg-6 ">
                  <p className="spacebar mt-3"></p>
                  <p className="mb-1">
                    Staffing Connect specializes in accounting and finance recruitment by connecting skilled professionals with organizations that value accuracy, compliance, and financial expertise. Whether it's roles in bookkeeping, financial analysis, auditing, or CFO-level positions, Staffing Connect ensures a tailored match through a consultative and efficient hiring process. With industry knowledge and a commitment to quality, they help businesses build strong financial teams and professionals advance their careers with confidence.
                  </p>
                  
                  <h6 className="mt-2">Our Commitment:</h6>
                  <p>
                    Staffing Connect delivers high-quality recruitment solutions for the accounting and finance industry. We connect employers with professionals who bring accuracy, integrity, and strategic insight. Our personalized, detail-focused approach ensures every placement supports long-term growth, compliance, and operational excellence—building lasting partnerships that strengthen financial teams and empower careers.
                  </p>
                </div>

                <div className="col-md-12 col-lg-12 mt-2">
                  <h6>Why chose Staffing Connect?</h6>

                  <ol className="ml-4">
                    <li>
                      <b>A Consultative, Personalized Process:</b>
                      <ul className="ml-3">
                        <li>
                          Staffing Connect applies a signature consultative approach to each search—whether it’s a key hire or part of a broader staffing solution—ensuring they truly understand client needs and candidate strengths to make the right match. 
                        </li>
                      </ul>
                    </li>
                    <li>
                      <b>Positive Candidate Experiences Reflect Their Supportive Service:</b>
                      <ul className="ml-3">
                        <li>
                          Candidates frequently praise their friendly, responsive, and professional service:
                        </li>
                        <li>
                            They were prompt in their response and helped me find a job that was a perfect fit… the staff was professional and friendly.
                        </li>
                        <li>
                            Such feedback, while not specific to accounting or finance, highlights strengths—like attentiveness and effective matching—that are invaluable when placing finance professionals in the right roles.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <b>Emphasis on Quality Over Quantity in Placements:</b>
                      <ul className="ml-3">
                        <li>
                          Their consultative model centers on finding the right person for the right job, rather than simply filling positions. This mindset aligns well with the finance sector, where precision, integrity, and long-term suitability are critical.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </div>
                <div className="col-md-12 col-lg-12 mt-2">
                  <h6>
                    Staffing Connect – Balancing talent and precision in accounting and finance recruitment.
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div
            className=" content-inner-2 footerImage"
            style={{
              backgroundImage: "url( " + bnr3 + ")",
              backgroundPosition: "bottom",
              backgroundRepeat: "repeat-x",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
